import type { BimActKc2TotalItemData } from 'gql/graphql';

import type { RowClassRules } from 'ag-grid-community';

export const getBimActCellClass: RowClassRules = {
    boldWeight: ({ data }: { data: BimActKc2TotalItemData }) =>
        data?.id < 4 || data?.id === 6 || data?.id === 24 || data?.id === 26,
    doubleLeftGap: ({ data }: { data: BimActKc2TotalItemData }) => !!data?.parentId || (data?.id > 14 && data?.id < 24),
    tripleLeftGap: ({ data }: { data: BimActKc2TotalItemData }) => data?.parentId === 8,
};
